import { swiper_children, bigScreen_swiper_children, app_swiper_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const swiperComponent = {
  name: "swiperComponent",
  desc: "轮播",
  render: () => import("./render/swiper-component.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "轮播",
        children: app_swiper_children,
        typeId: "1990b76a6a85e111ed0b1e4831eb1a817cdc",
        group: "element",
        sort: 30
      }
    ],
    bigScreen: [
      {
        name: "轮播",
        children: bigScreen_swiper_children,
        group: "element",
        sort: 10
      }
    ],
    portal: [
      {
        name: "轮播",
        children: swiper_children,
        group: "element",
        sort: 30
      }
    ]
  },
  toolbars: [
    {
      name: "swiperComponent",
      label: "轮播",
      comp: {
        swiperComponent: () => import("./toolbars/swiper-options-setting.vue"),
        swiperComponentSetting: () => import("./toolbars/swiper-options-setting.vue"),
        swiperComponentStyle: () => import("./toolbars/swiper-options-style.vue"),
        swiperComponentData: () => import("./toolbars/swiper-options-data.vue"),
        swiperComponentConfig: () => import("./toolbars/swiper-options-config.vue")
      }
    }
  ]
}

export default swiperComponent
